import React from "react";
import { NavLink } from "react-router-dom";
import { useLang } from "../context/LanguageContext";

export const Footer = () => {
  const { t } = useLang();
  const f = t.footer;
  const year = new Date().getFullYear();

  return (
    <footer className="relative bg-ink-950 pt-16 md:pt-20 pb-10 border-t border-white/10" data-testid="footer">
      <div className="max-w-7xl mx-auto px-6 lg:px-12">
        <div className="max-w-3xl">
          <p className="font-serif font-light text-3xl md:text-5xl text-white leading-tight tracking-tight">
            EBEN EZER <span className="italic text-gold">Taxi VIP</span>
          </p>
          <p className="mt-3 text-white/50 font-light md:text-lg max-w-lg">{f.tagline}</p>
        </div>

        <div className="mt-12 grid grid-cols-2 md:grid-cols-4 gap-8 border-t border-white/10 pt-10">
          <div>
            <p className="overline text-[10px] text-gold mb-4">Menu</p>
            <div className="flex flex-col gap-2">
              {[["/", t.nav.home], ["/vehicules", t.nav.vehicles], ["/offres", t.nav.offers], ["/avis", t.nav.reviews], ["/contact", t.nav.contact]].map(([to, label]) => (
                <NavLink key={to} to={to} className="text-white/60 hover:text-gold transition-colors font-light text-sm" data-testid={`footer-nav-${to}`}>{label}</NavLink>
              ))}
            </div>
          </div>
          <div>
            <p className="overline text-[10px] text-gold mb-4">Contact</p>
            <a href="tel:+32465641169" className="block text-white/60 hover:text-gold transition-colors font-light text-sm" data-testid="footer-phone">+32 465 64 11 69</a>
            <a href="mailto:info@ebenezertaxi.be" className="block text-white/60 hover:text-gold transition-colors font-light text-sm mt-1" data-testid="footer-email">info@ebenezertaxi.be</a>
          </div>
          <div>
            <p className="overline text-[10px] text-gold mb-4">{f.cancel}</p>
            <p className="text-white/45 font-light text-xs" data-testid="footer-cancel-policy">{f.cancelPolicy}</p>
          </div>
          <div>
            <p className="overline text-[10px] text-gold mb-4">Legal</p>
            <div className="flex flex-col gap-2">
              {[f.legal, f.terms, f.privacy].map((l, i) => (
                <a key={i} href="#" className="text-white/45 hover:text-gold transition-colors font-light text-xs" data-testid={`footer-legal-${i}`}>{l}</a>
              ))}
            </div>
          </div>
        </div>

        <div className="mt-10 pt-6 border-t border-white/10 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-white/30 text-xs font-light">© {year} EBEN EZER TAXI VIP · {f.rights}</p>
          <p className="overline text-[10px] text-white/30">Powered by Stripe · Made in Belgium</p>
        </div>
      </div>
    </footer>
  );
};
